import { queryOptions } from '@tanstack/react-query';

import { api } from '../client';
import { endpoints } from '../endpoints';
import { country, dictionaries, siteSettings, type WireCountry, type WireDictionaries, type WireSiteConfig } from '../wire';

export const siteQueries = {
  config: () =>
    queryOptions({
      queryKey: ['site', 'config'] as const,
      queryFn: async () => siteSettings(await api.get<WireSiteConfig>(endpoints.meta.config())),
      staleTime: 60_000,
      refetchOnWindowFocus: true,
    }),

  countries: () =>
    queryOptions({
      queryKey: ['site', 'countries'] as const,
      queryFn: async () => {
        const payload = await api.get<{ items?: WireCountry[] }>(endpoints.meta.countries());
        return (payload.items ?? []).map(country);
      },
      staleTime: 60 * 60_000,
    }),

  dictionaries: () =>
    queryOptions({
      queryKey: ['site', 'dictionaries'] as const,
      queryFn: async () => dictionaries(await api.get<WireDictionaries>(endpoints.meta.dictionaries())),
      staleTime: 10 * 60_000,
    }),
};
